class StickyHeader extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.safeZone = 250

    this.ignoreStickyElementInView = false // New flag for tracking ignore elements
    this.observeIgnoredElement() // Set up observer for the ignore element
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  observeIgnoredElement () {
    // Select elements that have the `data-sticky-header-ignore` attribute
    const ignoreElement = document.querySelector('[data-sticky-header-ignore]')

    if (ignoreElement) {
      const observer = new IntersectionObserver((entries) => {
        // If the ignore element is in view, set flag to true, else false
        entries.forEach((entry) => {
          this.ignoreStickyElementInView = entry.isIntersecting
        })
      })

      observer.observe(ignoreElement)
    }
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setSticky()
  }

  setSticky () {
    this.bodyElement.classList.toggle(
      this.dataset.classSticky,
      this.shouldBeSticky,
    )
  }

  get bodyElement () {
    return document.body
  }

  get shouldBeSticky () {
    return this.lastKnownY >= this.safeZone
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader)
}
